// Hook szczegółów oferty klienta CRM – GET /sales-crm/clients/:id/offers/:offerId

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

/** Pojedyncza oferta (zgodnie z kolumnami tabeli ofert w panelu + szczegóły karty) */
export interface ISalesCrmOffer {
  id: string;
  offer_name: string;
  offer_number: string;
  offer_date: string;
  value: string;
  /** Etykieta statusu (PL) - do wyświetlenia w widoku read-only. */
  status: string;
  /** Numeryczny status oferty (Offer::STATUS_*), do select-a w edytorze. */
  status_id?: number | null;
  client_name?: string;
  client_id?: number;
  /** Warunki handlowe – sposób płatności (reszta z /financial + klient) */
  payment_method?: string;
  /** Szczegóły oferty */
  created_at?: string;
  /** Data obowiązywania w formacie PL (do wyświetlenia). */
  valid_until?: string;
  /** Data obowiązywania w formacie ISO YYYY-MM-DD (do input type="date"). */
  valid_until_iso?: string | null;
  version?: string;
  author_name?: string;
  last_modified_at?: string;
  last_modified_by?: string;
  /** Flaga okresowości - klient może wielokrotnie zrealizować ofertę w okresie ważności. */
  is_periodic?: boolean;
  /** ID typu oferty (sales_crm_offer_type.id). */
  offer_type_id?: number | null;
  /**
   * Absolutny URL publicznej akceptacji - ustawiony tylko gdy typ oferty
   * EXTERNAL_ACCEPTANCE i token aktywny. Dla pozostalych typow `null`.
   */
  acceptance_url?: string | null;
}

const getSalesCrmClientOffer = (
  clientId: number,
  offerId: string,
  versionId?: number | null
): Promise<ISalesCrmOffer> => {
  return axios.get(`/sales-crm/clients/${clientId}/offers/${offerId}`, {
    params: versionId ? { versionId } : undefined
  });
};

export const useGetSalesCrmClientOffer = (
  clientId: number,
  offerId: string,
  versionId?: number | null,
  options?: UseQueryOptions<ISalesCrmOffer, IError>
) =>
  useQuery<ISalesCrmOffer, IError>(
    ['sales-crm', 'client', clientId, 'offer', offerId, 'version', versionId ?? 'actual'],
    () => getSalesCrmClientOffer(clientId, offerId, versionId),
    {
      ...options,
      enabled:
        (options?.enabled !== false) && clientId > 0 && String(offerId).trim().length > 0
    }
  );
